import React from 'react'
import FooterTwo from '../Components/Footer/FooterTwo'
import HeaderOne from '../Components/Header/HeaderOne'
import bannerBg from '../assets/img/Banners/NewContactUsBanner.jpg';
import PageBanner from '../Components/PageBanner';
import BrandCarouselThree from "../Components/Brands/BrandCarouselThree";
import ContactPageContents from "../Components/Contact/ContactPageContents";
import Pricing from '../Components/Price/Pricing';
import icon1 from "../assets/img/icons/p1.png";
import icon2 from "../assets/img/icons/p2.png";
import icon3 from "../assets/img/icons/p3.png";
import reliance  from "../assets/img/icons/reliancemart.png";

const OutletPage = () => {
  return (
    <> 
        <PageBanner title='Outlet' bannerBg={bannerBg} currentPage='Outlet' />
        {/* <Pricing/> */}

        <section className="pricing-wrapper section-padding pricing-bg">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-8 offset-lg-2">
                <div className="block-contents text-center">
                  <div className="section-title">
                    <span>Locations</span>
                    <h2>Our Offices & Factory</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="single-pricing-plan">
                  <div className="package-head">
                    <div className="icon">
                      <img src={icon1} alt="" />
                    </div>
                    <div className="package-title">
                      <h6>Factory:</h6>
                      {/* <h2>$49.00</h2> */}
                    </div>
                  </div>
                  <div className="package-features">
                    <span>PANCHASAR ROAD,</span>
                    <span>MORBI – 363 641 (Gujarat) INDIA</span>
                    <span>Ph No: +91-7600048000</span>
                    {/* <span>Fax No: +91-2822-250756</span> */}
                
                  </div>
                  {/* <div className="package-btn">
                    <Link to="/contact">Choose Plan</Link>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="single-pricing-plan">
                  <div className="package-head">
                    <div className="icon">
                      <img src={icon3} alt="" />
                    </div>
                    <div className="package-title">
                      <h6>Rajkot:</h6>
                      {/* <h2>$89.00</h2> */}
                    </div>
                  </div>
                  <div className="package-features">
                    <span>Shree Gita Gininig and oil industries <br /> Jalaram 2/2 corner, Near metro restaurant <br />University Road</span>
                    {/* <span>Ph No: +91-9925022545</span> */}
                    {/* <span>Fax No: +91-281-2701219</span> */}
                    {/* <span>Cell No: +91-9426999999</span> */}
                  </div>
                  {/* <div className="package-btn">
                    <Link to="/contact">Choose Plan</Link>
                  </div> */}
                </div>
              </div>
              {/* <div className="col-lg-3 col-md-6 col-12"></div> */}
              <div className="col-lg-6 col-md-6 col-12">
                <div className="single-pricing-plan  ">
                  <div className="package-head">
                    <div className="icon">
                      <img src={icon2} alt="" />
                    </div>
                    <div className="package-title">
                      <h6>Ahmedabad:</h6>
                      {/* <h2>$69.00</h2> */}
                    </div>
                  </div>
                  <div className="package-features">
                    <span>Shree Gita Gininig and oil industries <br />Shop No. E-41, (Safal -4) Sumel Business Park - I,<br /> NR. Kalupur Bridge, Amdupura</span>
                 
                    {/* <span>Ph No: +91-281-2579901 / 2579902</span>
                    <span>Fax No: +91-281-2579903</span> */}
                  </div>
                  {/* <div className="package-btn">
                    <Link to="/contact">Choose Plan</Link>
                  </div> */}
                </div>
              </div>
              {/* <div className="col-lg-3 col-md-6 col-12"></div> */}

              <div className="col-lg-6 col-md-6 col-12" >
                <div className="single-pricing-plan" style={{
                  // paddingBottom:"80px"
                }}>
                  <div className="package-head">
                    <div className="icon">
                      <img src={icon3} alt="" />
                    </div>
                    <div className="package-title">
                      <h6>Morbi (Factory):</h6>
                      {/* <h2>$89.00</h2> */}
                    </div>
                  </div>
                  <div className="package-features">
                    <span>Shree Gita Gininig and oil industries, <br />Panchasar Road,<br /> Morbi </span>
                  </div>
                  {/* <div className="package-btn">
                    <Link to="/contact">Choose Plan</Link>
                  </div> */}
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-12" >
                <div className="single-pricing-plan" style={{
                  // paddingBottom:"80px"
                }}>
                  <div className="package-head">
                    <div className="icon">
                      <img src={reliance} alt="ed" style={{width:'25%'}}/>
                    </div>
                    <div className="package-title">
                      <h6>Partnered with reliance mart</h6>
                      {/* <h2>$89.00</h2> */}
                    </div>
                  </div>
                  <div className="package-features">
                    {/* <span>Shree Gita Gininig and oil industries, <br />Panchasar Road,<br /> Morbi </span> */}
                  </div>
                  {/* <div className="package-btn">
                    <Link to="/contact">Choose Plan</Link>
                  </div> */}
                </div>
              </div>              
              
            </div>
          </div>
        </section>        
        {/* <BrandCarouselThree/> */}
        
    </>
  )
}

export default OutletPage;
